import { Download, FileText, Receipt, Send, Trash2 } from "lucide-react";
import { formatDate } from "../../ui";

export const FileRow = ({ f, resendingId, issuingReceiptId, onDownload, onResend, onIssue, onRemove }) => (
              <li
                data-testid={`admin-file-row-${f.id}`}
                className="flex items-center justify-between gap-3 p-4 hover:bg-slate-50"
              >
                <div className="flex items-start gap-4 min-w-0">
                  <div className="h-10 w-10 grid place-items-center rounded-sm bg-slate-100 text-slate-600 shrink-0">
                    <FileText size={18} strokeWidth={1.4} />
                  </div>
                  <div className="min-w-0">
                    <div className="font-medium truncate flex items-center gap-2 flex-wrap">
                      <span className="truncate">{f.title}</span>
                      {f.tag === "Boleto" && f.payment_status && (
                        <span
                          data-testid={`admin-file-payment-${f.id}`}
                          className={`px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-wide shrink-0 ${
                            f.payment_status === "pago"
                              ? "bg-emerald-100 text-emerald-800 border border-emerald-300"
                              : "bg-amber-50 text-amber-800 border border-amber-300"
                          }`}
                        >
                          {f.payment_status === "pago" ? "Pago" : "Em aberto"}
                        </span>
                      )}
                      {f.first_open && (
                        <span
                          data-testid={`admin-file-opened-${f.id}`}
                          title={`Aberto pela primeira vez em ${new Date(f.first_open.opened_at).toLocaleString("pt-BR")}`}
                          className="inline-flex items-center gap-1 px-2 py-0.5 bg-emerald-50 border border-emerald-200 rounded-sm text-[10px] uppercase tracking-wide text-emerald-800 shrink-0"
                        >
                          ✓ Aberto por{" "}
                          <strong className="normal-case tracking-normal">
                            {f.first_open.recipient}
                          </strong>
                        </span>
                      )}
                    </div>
                    <div className="text-xs text-slate-500 flex flex-wrap items-center gap-2 mt-0.5">
                      <span className="px-2 py-0.5 bg-slate-100 border border-slate-200 rounded-sm text-[10px] uppercase tracking-wide">
                        {f.tag}
                      </span>
                      <span>{formatDate(f.uploaded_at)}</span>
                      <span>•</span>
                      <span>
                        {f.assigned_to?.includes("__all__")
                          ? "Todos"
                          : `${f.assigned_to?.length || 0} associado(s)`}
                      </span>
                      {f.available === false && (
                        <span
                          data-testid={`admin-file-unavailable-${f.id}`}
                          className="px-2 py-0.5 bg-rose-50 border border-rose-200 rounded-sm text-[10px] uppercase tracking-wide text-rose-700"
                          title="Arquivo físico ausente — reenvie."
                        >
                          Indisponível
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex gap-2">
                  <button
                    data-testid={`admin-dl-${f.id}`}
                    onClick={() => onDownload(f)}
                    disabled={f.available === false}
                    className="inline-flex items-center gap-2 px-3 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776] disabled:opacity-40 disabled:cursor-not-allowed"
                    title="Baixar"
                  >
                    <Download size={14} />
                  </button>
                  <button
                    data-testid={`admin-resend-${f.id}`}
                    onClick={() => onResend(f)}
                    disabled={f.available === false || resendingId === f.id}
                    className="inline-flex items-center gap-2 px-3 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776] hover:text-[#002776] disabled:opacity-40 disabled:cursor-not-allowed"
                    title="Reenviar por e-mail aos destinatários"
                  >
                    <Send size={14} className={resendingId === f.id ? "animate-pulse" : ""} />
                  </button>
                  {f.tag === "Boleto" && (
                    <button
                      data-testid={`admin-issue-receipt-${f.id}`}
                      onClick={() => onIssue(f)}
                      disabled={
                        f.available === false ||
                        issuingReceiptId === f.id ||
                        !f.valor ||
                        !f.numero_boleto
                      }
                      className={`inline-flex items-center gap-2 px-3 py-2 border text-[11px] uppercase tracking-[0.22em] disabled:opacity-40 disabled:cursor-not-allowed ${
                        f.payment_status === "pago"
                          ? "border-emerald-400 text-emerald-700 hover:bg-emerald-50"
                          : "border-slate-300 hover:border-[#002776] hover:text-[#002776]"
                      }`}
                      title={
                        !f.numero_boleto
                          ? "Número do boleto não identificado no nome do arquivo"
                          : !f.valor
                          ? "Boleto sem valor cadastrado"
                          : f.payment_status === "pago"
                          ? "Recibo já emitido — clique para baixar de novo"
                          : "Emitir e baixar recibo (marca como pago)"
                      }
                    >
                      <Receipt size={14} className={issuingReceiptId === f.id ? "animate-pulse" : ""} />
                    </button>
                  )}
                  <button
                    data-testid={`admin-del-${f.id}`}
                    onClick={() => onRemove(f.id)}
                    className="inline-flex items-center gap-2 px-3 py-2 border border-rose-300 text-rose-700 text-[11px] uppercase tracking-[0.22em] hover:bg-rose-50"
                    title="Excluir"
                  >
                    <Trash2 size={14} />
                  </button>
                </div>
              </li>
);
